<template>
  <ag-grid-vue
    style="width: 1010px; height: 100%"
    class="ag-theme-material"
    :rowData="rowData"
    :columnDefs="columnDefs"
    :frameworkComponents="frameworkComponents"
    :context="context"
    :getContextMenuItems="getContextMenuItems"
  >
  </ag-grid-vue>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue'
  import 'ag-grid-enterprise'
  import AgGridRoleSelect from '../inputs/AgGridRoleSelect'
  import PermissionsAPI from '@/api/PermissionsAPI'
  import AgGridButtonRenderer from './AgGridButtonRenderer'
  import Toast from '@/components/common/toasts'
  import { SET_USERS } from '@/appLogic/permissions/store/constants'

  export default {
    components: {
      AgGridVue,
      AgGridButtonRenderer,
    },
    props: {
      copiedUserList: {
        type: Array,
      },
      rolesList: {
        type: Array,
      },
    },
    data() {
      return {
        rowData: null,
        columnDefs: null,
        frameworkComponents: null,
        context: null,
      }
    },
    beforeMount() {
      this.columnDefs = [
        {
          headerName: '',
          field: 'value',
          cellRendererFramework: 'AgGridButtonRenderer',
          colId: 'params',
          width: 80,
          autoHeight: true,
        },
        {
          headerName: 'First Name',
          field: 'first_name',
          filter: 'agTextColumnFilter',
          sortable: true,
          resizable: true,
        },
        { headerName: 'Last Name', field: 'last_name', filter: 'agTextColumnFilter', sortable: true, resizable: true },
        { headerName: 'Email', field: 'email', filter: 'agTextColumnFilter', sortable: true, resizable: true },
        {
          headerName: 'Roles',
          field: 'roles',
          cellEditorFramework: AgGridRoleSelect,
          cellEditorPopup: true,
          editable: true,
          width: 300,
          minWidth: 300,
          valueGetter: params => this.getRoles(params),
          sortable: true,
          resizable: true,
          filter: 'agTextColumnFilter',
        },
      ]
      this.context = { componentParent: this }
      this.frameworkComponents = {
        agGridButtonRenderer: AgGridButtonRenderer,
      }
      this.rowData = this.copiedUserList ? this.copiedUserList : null
      /* eslint-disable */
      this.autoGroupColumnDef = {
        headerName: '',
        cellRendererParams: { suppressCount: true },
      }
    },
    mounted() {
      this.rowData = this.copiedUserList && this.copiedUserList.length ? this.copiedUserList : null
    },
    computed: {},
    watch: {
      copiedUserList() {
        if (this.copiedUserList && this.copiedUserList.length) {
          this.rowData = this.copiedUserList
        }
      },
    },
    methods: {
      setUserToDelete(user) {
        this.$parent.setUserToDelete(user)
      },
      getDataPath(data) {
        return data.categoryTree
      },
      onGridReady(params) {
        params.api.sizeColumnsToFit()
      },
      getRoles(params) {
        if (params) {
          const roleIds = params.data.roles
          if (!roleIds) {
            return ''
          } else {
            const roleNamesArray = roleIds.map(roleId => {
              const rn = this.rolesList.filter(el => el.id === roleId)[0]
              return rn && rn.name ? '\xa0' + rn.name : ''
            })
            return roleNamesArray ? roleNamesArray : ''
          }
        }
      },
      getContextMenuItems(params) {
        return [
          'copy',
          'copyWithHeaders',
          'separator',
          {
            name: 'Clear All Filters',
            action: () => {
              this.$router.push({})
              params.api.setFilterModel(null)
            },
          },
        ]
      },
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// UserList.vue?08dbc0d4